export const DEFAULT_CONTAINER_QUERY_OBSERVER_STATE = false;
